module.exports = __webpack_public_path__ + "static/media/barbara1.9e7771b7.mp3";